import { render, staticRenderFns } from "./root.vue?vue&type=template&id=6e777fb4&scoped=true&"
import script from "./root.vue?vue&type=script&lang=ts&"
export * from "./root.vue?vue&type=script&lang=ts&"
import style0 from "./root.vue?vue&type=style&index=0&id=6e777fb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e777fb4",
  null
  
)

component.options.__file = "root.vue"
export default component.exports